import { useCallback, useState } from 'react';
import { Tekster } from '../types/apptekster';
import { useApptekster } from '../contexts/ApptekstContext';

export const useFeil = (feilobjekt: { [key: string]: keyof Tekster }) => {
    const t = useApptekster();
    const [fo] = useState(feilobjekt);

    const tilFeilmelding = useCallback(
        (feilkode: string) => t(fo[feilkode] || fo.default),
        [fo, t],
    );

    return { tilFeilmelding };
};
